import cAppeared from './components/c-appeared';
import cOutline from './components/c-outline';
import preloader from './components/c-preloader';
import cLanguageSwitcher from './components/c-language-switcher';
import choices from './components/c-choices';
import header from './blocks/header';
import footer from './blocks/footer';
import form from './blocks/form';
import nav from './blocks/nav/nav';
import clock from './clock';
import calculateScrollBarWidth from './utils/calculateScrollBarWidth';

cAppeared();
cOutline();
preloader();
cLanguageSwitcher();

// on some cases (webview) we don't need header and nav
if (document.querySelector('.js-header')) {
  header();
  nav();
}

footer();
form();
choices();
clock();
calculateScrollBarWidth('--scroll-bar-width');
